import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';
import { UserType } from '../../../../@shelter/enums/user-type.enum';
import { UserService } from '../../user/user.service';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate, CanActivateChild {
  constructor(
    private _authService: AuthService,
    private _userService: UserService,
    private _router: Router
  ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkUserisLogedInAndAdmin();
  }


  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkUserisLogedInAndAdmin();
  }
  private checkUserisLogedInAndAdmin(): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this._authService.check().pipe(switchMap(res => {
      if (!res) {
        return of(false);
      } else {
        return this._userService.user$.pipe(switchMap(user => {
          if (user.userType === UserType.Admin || user.userType === UserType.Auditor || user.userType === UserType.Supplier) {
            return of(true)
          } else if (user.userType === UserType.Seller) {
            console.log(user.userType);
            
            this._router.navigate(['/seller'])
            return of (false)
          }else{
            return of (false)
          }
        }));
      }
    }));
  }

}
